import styled from 'styled-components'
import {Cta, Price} from './Hero'
import * as content from './Hero/content'

TrailingCta = ()->
	<Wrapper>
		<div className="hero-bg" />
		<Content dangerouslySetInnerHTML={__html:content.inclusions} />
		<div className="hero-content-divider centered" />
		<Price centered />
		<Cta centered />
	</Wrapper>


Wrapper = styled.div"""
	position: relative
	margin-top: 30px
	padding: 40px 20px
"""

Content = styled.div"""
	font-size: 26px
	line-height: 36px
	text-align: center

	@media(max-width:812px) {
		font-size: 22px
		line-height: 30px
	}
"""


export default TrailingCta